<template>
  <div class="container">
    <Breadcrumb class="breadcrumb" separator="»">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <BreadcrumbItem>学习中心</BreadcrumbItem>
      <BreadcrumbItem>{{ courseName }}</BreadcrumbItem>
      <BreadcrumbItem>{{ typeName }}</BreadcrumbItem>
    </Breadcrumb>

    <div class="practice-header">
      <div class="practice-title">
        <h1>{{ simExamInfo.ExamName }}</h1>
        <div class="practice-title-note">
          <span style="margin-right: 30px"
            >答题时间：{{ simExamInfo.ExamTime }} 分钟</span
          >
          <span style="margin-right: 30px"
            >总题数：{{ simExamInfo.ExerNum }} 题</span
          >
          <span style="margin-right: 30px"
            >总分：{{ simExamInfo.TotalScore }} 分</span
          >
          <span style="margin-right: 30px"
            >类别：{{ simExamInfo.SimType }}</span
          >
          <template v-if="simExamRecord.finish && simExamRecord.isRated">
            <span
              class="color1"
              style="cursor: pointer"
              @click="teacherRemarkVisible = true"
              >查看教师评语</span
            >
            <Drawer
              title="教师评语"
              :closable="false"
              width="700"
              v-model="teacherRemarkVisible"
            >
              <div v-html="simExamRecord.remark"></div>
            </Drawer>
          </template>
        </div>
      </div>
    </div>
    <!-- 条件限制展示区 -->
    <div class="practice-header" style="margin: 2rem auto" v-show="isMaxNum">
      <div style="text-align: center; font-size: 1.6rem">参与考试次数已满</div>
    </div>
    <div class="practice-header" style="margin: 2rem auto" v-show="isOutTime">
      <div style="text-align: center; font-size: 1.6rem">
        未在考试指定的时间
      </div>
    </div>
    <div
      class="practice-header"
      style="margin: 2rem auto"
      v-show="!isRated && isViewAnalysis == 0"
    >
      <div style="text-align: center; font-size: 1.6rem">
        该考卷为教师评分，请耐心等候教师评分后查看结果
        <p style="margin-top:30px;">
          <Button type="primary" @click="viewAnalysis">查看解析</Button>
        </p>
      </div>
    </div>

    <!-- 题目区 -->
    <div
      class="practice-container clearfix"
      v-if="(!isMaxNum && !isOutTime && isRated) || isViewAnalysis == 1"
    >
      <div class="fl practice-main">
        <practice-item
          v-for="(item, index) in exerciseList"
          :key="index"
          :data="item"
          :index="index"
          v-model="item.userKey"
          practiceType="simexam"
          :positionId="simId"
          :finish="simExamRecord.finish"
          :scoreMethod="simExamInfo.ScoringMethod"
          :isRated="simExamRecord.isRated"
          @on-mark="sheetMark"
        ></practice-item>
      </div>
      <div class="fr practice-bar">
        <Affix :offset-top="160">
          <div class="practice-time">
            <Icon type="md-stopwatch" size="16" />考试剩余时间
            <b>{{ remainingTime }}</b> 分钟
          </div>
          <div class="practice-sheet">
            <h3 class="practice-sheet-header">答题卡</h3>
            <p class="practice-sheet-note">点击图标跳转到对应的题目</p>
            <div class="practice-sheet-score" v-show="simExamRecord.finish">
              <p
                v-if="
                  simExamRecord.scoringMethod === 1 || simExamRecord.isAllRated
                "
              >
                本次考试得分：
                <span class="right-rate">{{ simExamRecord.score }}</span> 分
              </p>
            </div>
            <div class="practice-sheet-list">
              <happy-scroll
                color="rgba(12, 154, 213 , 1)"
                size="5"
                resize
                hide-horizontal
              >
                <!-- 排序答题卡 -->
                <ul
                  class="practice-sheet-serial clearfix"
                  v-if="simExamRecord.finish && exerSortType == 2"
                >
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right:
                        item.doResult == 1 ||
                        (item.userScore > 0 && item.userScore == item.score),
                      wrong: item.doResult == -1,
                      mark:
                        item.doResult != 0 &&
                        item.userScore > 0 &&
                        item.userScore < item.score,
                    }"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>
                </ul>
                <!-- 排序答题卡 -->
                <ul
                  class="practice-sheet-serial clearfix"
                  v-if="!simExamRecord.finish && exerSortType == 2"
                >
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{ mark: item.isMark, already: item.doResult != 0 }"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>
                </ul>
                <!-- 题型答题卡 -->
                <ul
                  class="practice-sheet-serial clearfix"
                  v-if="simExamRecord.finish && exerSortType == 1"
                >
                  <div v-if="singleFlag == true">单选题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right:
                        item.doResult == 1 ||
                        (item.userScore > 0 && item.userScore == item.score),
                      wrong: item.doResult == -1,
                      mark:
                        item.doResult != 0 &&
                        item.userScore > 0 &&
                        item.userScore < item.score,
                    }"
                    v-if="singleFlag == true && item.newKeyType == 1"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>

                  <div v-if="multipleFlag == true">多选题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right:
                        item.doResult == 1 ||
                        (item.userScore > 0 && item.userScore == item.score),
                      wrong: item.doResult == -1,
                      mark:
                        item.doResult != 0 &&
                        item.userScore > 0 &&
                        item.userScore < item.score,
                    }"
                    v-if="multipleFlag == true && item.newKeyType == 2"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>

                  <div v-if="subjectiveFlag == true">主观题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right:
                        item.doResult == 1 ||
                        (item.userScore > 0 && item.userScore == item.score),
                      wrong: item.doResult == -1,
                    }"
                    v-if="subjectiveFlag == true && item.newKeyType == 3"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>
                </ul>

                <!-- 题型答题卡 -->
                <ul
                  class="practice-sheet-serial clearfix"
                  v-if="!simExamRecord.finish && exerSortType == 1"
                >
                  <div v-if="singleFlag == true">单选题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{ mark: item.isMark, already: item.doResult != 0 }"
                    v-if="singleFlag == true && item.newKeyType == 1"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>

                  <div v-if="multipleFlag == true">多选题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{ mark: item.isMark, already: item.doResult != 0 }"
                    v-if="multipleFlag == true && item.newKeyType == 2"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>

                  <div v-if="subjectiveFlag == true">主观题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{ mark: item.isMark, already: item.doResult != 0 }"
                    v-if="subjectiveFlag == true && item.newKeyType == 3"
                  >
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>
                </ul>
              </happy-scroll>
            </div>

            <div class="practice-sheet-button" v-if="!simExamRecord.finish">
              <Button type="primary" long @click="saveSimExam">保存进度</Button>
            </div>
            <div class="practice-sheet-button" v-if="!simExamRecord.finish">
              <Button type="warning" long @click="postSimExam">我要交卷</Button>
            </div>
            <div
              class="practice-sheet-button"
              v-if="simExamRecord.finish && !isViewAnalysis"
            >
              <Button type="warning" long @click="resetDoResult"
                >重做一遍</Button
              >
            </div>
            <div class="practice-sheet-footer" v-if="simExamRecord.finish">
              <span>
                <i class="ivu-icon ivu-icon-md-square right"></i> 正确
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square mark"></i> 部分得分
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square wrong"></i> 错误
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square empty"></i> 未做
              </span>
            </div>
            <div class="practice-sheet-footer" v-else>
              <span>
                <i class="ivu-icon ivu-icon-md-square mark"></i> 标记
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square already"></i> 已做
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square empty"></i> 未做
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square rated"></i> 未评分
              </span>
            </div>
          </div>
        </Affix>
      </div>
    </div>
    <!-- END 题目区 -->
    <Modal
      v-model="selfScoreModalVibible"
      :closable="false"
      :mask-closable="false"
      width="360"
      class-name="vertical-center-modal"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span style="margin-left: 0.5rem">温馨提示</span>
      </p>
      <p>
        本次做题包含主观题，
        <br />检测到答题卡中有未评分的题目，
        <br />需要手动评分，才能评估完整答题结果
      </p>
      <div slot="footer" style="text-align: center">
        <Button
          type="error"
          size="large"
          @click="continueSubmit"
          style="margin-right: 30px"
          >放弃评分</Button
        >
        <Button
          type="success"
          size="large"
          @click="selfScoreModalVibible = false"
          >立即手动评分</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from '../../utils/mixin';
import PracticeItem from '../../components/exercise/PracticeItem';
import { HappyScroll } from 'vue-happy-scroll';
import 'vue-happy-scroll/docs/happy-scroll.css';
import { study } from '../../request';
export default {
  mixins: [siteMixin],
  data() {
    return {
      simExamInfo: {},
      exerciseList: [],
      simId: 0,
      srId: 0,
      remainingTime: '00:00',
      simExamRecord: {},
      courseName: '',
      selfScoreModalVibible: false,
      teacherRemarkVisible: false,
      exerSortType: 1, //答题排序
      singleFlag: false, //答题卡单选
      multipleFlag: false, //答题卡多选
      subjectiveFlag: false, //答题卡主观
      typeName: '',
      isViewAnalysis: 0, //是否查看解析
    };
  },
  computed: {
    //是否超过次数限制
    isMaxNum() {
      return (
        this.simExamRecord.simExamCount > 0 &&
        this.simExamRecord.simCount >= this.simExamRecord.simExamCount &&
        !this.simExamRecord.finish
      );
    },
    //是否超过有效期
    isOutTime() {
      return !this.simExamRecord.finish && this.simExamRecord.isOpened == 0;
    },
    //是否评过分
    isRated() {
      let rate = true;
      if (
        this.simExamRecord.scoringMethod == 2 &&
        this.simExamRecord.isRated == 0 &&
        this.simExamRecord.finish
      ) {
        rate = false;
      }
      return rate;
    },
  },
  mounted() {
    // this.setMetaData("模拟考试");
    this.initParams();
  },
  methods: {
    initParams() {
      this.simId = this.$route.params.id;
      this.setUmcId(this.$route.query.umcid);
      this.srId = this.$route.query.srid;
      this.isViewAnalysis = this.$route.query.an || 0;
      if (!this.simId || !this.umcId) {
        this.$Message.error('操作异常，参数传输错误！');
        return;
      }
      this.getCourseName();
    },
    getCourseName() {
      study.getUmcInfo(this.umcId).then(res => {
        if (res.status === 1) {
          this.courseName = res.data.courseName;
          this.setCourseId(res.data.courseId);
          this.getData();
        }
      });
    },
    getData() {
      if (this.srId && this.srId > 0) {
        this.isHistory = 0;
        this.getExerciseStoreList();
        this.getSimExamRecord();
      } else {
        this.isHistory = -2;
        study
          .getSimExamRecordId(this.umcId, this.courseId, this.simId)
          .then(res => {
            //console.log(res);
            if (res.status === 1) {
              this.srId = res.data;
              this.getExerciseStoreList();
              this.getSimExamRecord();
            }
          });
      }
    },
    getSimExamRecord() {
      const req = {
        srId: this.srId,
        umcId: this.$route.query.umcid,
        page: this.isHistory,
      };
      study.getSimExamHistoryInfo(req).then(res => {
        console.log(res);
        if (res.status === 1) {
          this.simExamRecord = res.data;
          this.countDownTimer();
        }
      });
    },
    getExerciseStoreList() {
      study
        .getSimExamExerciseListWithSrId(this.umcId, this.srId, this.isHistory)
        .then(res => {
          console.log('simExamExercise', res);
          if (res.status === 1) {
            const result = res.data;
            this.typeName = result.htExam == 0 ? '模拟考试' : '期末考试';
            if ([4688].includes(this.siteConfig.agencyId)) {
              this.typeName = '考试';
            }
            this.setMetaData(this.typeName);
            this.simExamInfo = result.SimExamStore;
            this.exerSortType = this.simExamInfo.ExerSortType;
            this.exerciseList = result.simExamExerciseListPage;
            this.exerciseList.forEach(item => {
              if (item.newKeyType == 1 && !this.singleFlag) {
                this.singleFlag = true;
              }
              if (item.newKeyType == 2 && !this.multipleFlag) {
                this.multipleFlag = true;
              }
              if (item.newKeyType == 3 && !this.subjectiveFlag) {
                this.subjectiveFlag = true;
              }
              if (item.userKey || item.starCount > 0 || item.userScore > 0) {
                if (this.getAnswerIsRight(item)) {
                  this.$set(item, 'doResult', 1);
                } else {
                  this.$set(item, 'doResult', -1);
                }
              } else {
                this.$set(item, 'doResult', 0);
              }
              if (item.newKeyType) {
                if (item.newKeyType == 1) {
                  item.keyType = '单选';
                }
                if (item.newKeyType == 2) {
                  item.keyType = '多选';
                }
              }
              console.log(item.ueId, item.doResult);
            });
          }
        });
    },
    sheetMark(item) {
      if (item.isMark) {
        item.isMark = true;
      } else {
        this.$set(item, 'isMark', true);
      }
    },
    countDownTimer() {
      this.totalSecond = this.simExamRecord.examTime * 60;
      const usedSecond = this.simExamRecord.time;
      this.downSecond = this.totalSecond - usedSecond;
      const isFinish = this.simExamRecord.finish;
      if (isFinish) return;
      this.timer = setInterval(() => {
        this.downSecond--;
        this.countDownTimerShow(this.downSecond);
      }, 1000);
    },
    countDownTimerShow(s) {
      let minute = Math.floor(s / 60);
      let second = Math.floor(s % 60);
      this.remainingTime = `${minute}:${second}`;
      if (s == 0) clearInterval(this.timer);
    },
    saveSimExam() {
      let lastPosition = 0;
      let ueIdSet = '';
      let userKeySet = '';
      let starSet = '';
      let imageSet = '';
      this.exerciseList.forEach((item, index) => {
        if (item.userKey != '' || item.userKeyImg1) {
          if (ueIdSet) ueIdSet += '|';
          if (userKeySet) userKeySet += '|';
          if (starSet) starSet += '|';
          if (imageSet) imageSet += '|';
          ueIdSet += item.ueId;
          //userKeySet += item.userKey;
          starSet += item.starCount;
          lastPosition = index + 1;
          //答案处理
          if (item.userKey != '') {
            userKeySet += item.userKey;
          } else {
            userKeySet += '-';
          }

          //主观题答案图片
          if (item.userKeyImg1) {
            imageSet += item.userKeyImg1;
            if (item.userKeyImg2) {
              imageSet += `,${item.userKeyImg2}`;
            }
            if (item.userKeyImg3) {
              imageSet += `,${item.userKeyImg3}`;
            }
          } else {
            imageSet += '-';
          }
        }
      });
      if (userKeySet == '') {
        this.$Message.info('还没有做题，无法保存');
        return;
      }
      userKeySet = userKeySet.replace(/-/g, '');
      imageSet = imageSet.replace(/-/g, '');
      let data = {
        srid: this.srId,
        simId: this.simId,
        umcId: this.umcId,
        time: this.totalSecond - this.downSecond || 10,
        lastposition: lastPosition,
        ueidset: ueIdSet,
        userkeyset: userKeySet,
        starcounts: starSet,
        userKeyImgset: imageSet,
      };
      study.saveSimExamRecord(data).then(res => {
        if (res.status === 1) {
          this.$Message.success('进度保存成功');
          setTimeout(() => {
            this.$router.push({
              name: 'CourseStudy',
              params: { cid: this.courseId },
            });
          }, 1500);
        } else {
          this.$Message.error('进度保存失败');
        }
      });
    },
    postSimExam() {
      let ueIdSet = '';
      let userKeySet = '';
      let starSet = '';
      let scores = 0;
      let resultSet = '';
      let keyTypeSet = '';
      let isAllRated = true;
      let imageSet = '';
      this.exerciseList.forEach((item, index) => {
        if (ueIdSet) ueIdSet += '|';
        if (userKeySet || index == 1) userKeySet += '|';
        if (starSet) starSet += '|';
        if (resultSet) resultSet += '|';
        if (keyTypeSet) keyTypeSet += '|';
        if (imageSet || index == 1) imageSet += '|';
        ueIdSet += item.ueId;
        userKeySet += item.userKey;
        starSet += item.starCount;
        if (item.starCount == 0 && this.optionType(item.keyType) == '1') {
          isAllRated = false;
        }
        if (item.doResult == 1) {
          //不定项选择评分时，得分类型根据规则（item.scoreRules）调整为主观题，用于后端存入当前题评分
          if (this.optionType(item.keyType, item.scoreRules) == '1') {
            if (item.currentScore) scores += Number(item.currentScore);
          } else {
            scores += item.score;
          }
          resultSet += '1';
        } else {
          if (this.optionType(item.keyType) == '1' && item.currentScore) {
            scores += Number(item.currentScore);
          }
          resultSet += '0';
        }
        keyTypeSet += this.optionType(item.keyType, item.scoreRules);

        //主观题答案图片
        if (item.userKeyImg1) {
          imageSet += item.userKeyImg1;
          if (item.userKeyImg2) {
            imageSet += `,${item.userKeyImg2}`;
          }
          if (item.userKeyImg3) {
            imageSet += `,${item.userKeyImg3}`;
          }
        }
      });

      //设置需提交的数据
      this.ueIdSet = ueIdSet;
      this.userKeySet = userKeySet;
      this.starSet = starSet;
      this.resultSet = resultSet;
      this.keyTypeSet = keyTypeSet;
      this.scores = scores;
      this.imageSet = imageSet;

      if (this.simExamInfo.ScoringMethod == 1 && !isAllRated) {
        this.selfScoreModalVibible = true;
      } else {
        this.submitSimExam();
      }
    },
    //有未评分的强制继续提交
    continueSubmit() {
      this.selfScoreModalVibible = false;
      this.submitSimExam();
    },
    submitSimExam() {
      this.$Spin.show();
      let data = {
        umcid: this.umcId,
        srid: this.srId,
        time: this.totalSecond - this.downSecond,
        scoringmethod: this.simExamInfo.ScoringMethod,
        ueidset: this.ueIdSet,
        userkeyset: this.userKeySet,
        starcounts: this.starSet,
        score: this.scores,
        resultset: this.resultSet,
        keytype: this.keyTypeSet,
        courseId: this.courseId,
        userKeyImgset: this.imageSet,
      };
      study.postSimExamRecord(data).then(res => {
        console.log(res);
        if (res.status === 1) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.$router.push({
              name: 'SimExam',
              params: { id: this.simId },
              query: { umcid: this.umcId, srid: this.srId },
            });
            this.reloadPage();
          }, 1500);
        } else {
          this.$Message.error('提交失败');
        }
        this.$Spin.hide();
      });
    },
    //重做
    resetDoResult() {
      this.$router.push({
        name: 'SimExam',
        params: { id: this.simId },
        query: { umcid: this.umcId },
      });
      this.reloadPage();
    },
    getAnswerIsRight(item) {
      if (
        this.optionType(item.keyType) == '0' ||
        this.optionType(item.newKeyType) == '0'
      ) {
        if (item.userKey.trim() == item.rightKey.trim()) return true;
        else return false;
      } else {
        const passScore = Number(item.score) / 2;
        const isRight = Number(item.userScore) >= passScore;
        if (item.starCount > 3 || isRight) return true;
        else return false;
      }
    },
    optionType(keyType, rule) {
      rule = rule || 0;
      if (
        keyType == '单选' ||
        keyType == '判断' ||
        keyType == '多选' ||
        keyType == '1' ||
        keyType == '2'
      ) {
        return rule > 0 && keyType == '多选' ? '1' : '0';
      } else {
        return '1';
      }
    },
    scrollPosition: function(i) {
      var top = document.querySelectorAll('.practice-item')[i].offsetTop - 162;
      window.scroll({ top: top, left: 0, behavior: 'smooth' });
    },
    viewAnalysis() {
      this.$router.push({
        name: 'SimExam',
        params: { id: this.simId },
        query: { umcid: this.umcId, srid: this.srId, an: 1 },
      });
      this.reloadPage();
    },
  },
  components: {
    PracticeItem,
    HappyScroll,
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/css/var';
@import '../../assets/css/exercise';
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
.viewRemark {
  position: absolute;
  right: 0;
  top: 12px;
  font-size: 1.6rem;
  color: orangered;
}
</style>
